/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_MotivationInputs */

const en_us2_profile_row_motivation = /** @type {(inputs: Profile_Row_MotivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivation`)
};

const pt_br2_profile_row_motivation = /** @type {(inputs: Profile_Row_MotivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivação`)
};

const es_419_profile_row_motivation = /** @type {(inputs: Profile_Row_MotivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivación`)
};

const pt_pt2_profile_row_motivation = /** @type {(inputs: Profile_Row_MotivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivação`)
};

const fr_fr2_profile_row_motivation = /** @type {(inputs: Profile_Row_MotivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivation`)
};

const de_de2_profile_row_motivation = /** @type {(inputs: Profile_Row_MotivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivation`)
};

const it_it2_profile_row_motivation = /** @type {(inputs: Profile_Row_MotivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivazione`)
};

/**
* | output |
* | --- |
* | "Motivation" |
*
* @param {Profile_Row_MotivationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_motivation = /** @type {((inputs?: Profile_Row_MotivationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_MotivationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_motivation(inputs)
	if (locale === "es-419") return es_419_profile_row_motivation(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_motivation(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_motivation(inputs)
	if (locale === "de-DE") return de_de2_profile_row_motivation(inputs)
	if (locale === "it-IT") return it_it2_profile_row_motivation(inputs)
	return en_us2_profile_row_motivation(inputs)
});
export { profile_row_motivation as "profile.row_motivation" }